export const TherapyType = {
  Individual: 'INDIVIDUAL',
  FamilyPartner: 'FAMILY_PARTNER',
  FamilyChild: 'FAMILY_CHILD'
}
